import { jsx as _jsx } from "react/jsx-runtime";
import { getGenresByIds, isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
const b = bemClassBuilder('v-film-genres');
export const FilmGenres = observer(() => {
    const i18n = useI18n();
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { film } = useFilmContext();
    if (!film)
        return enableSkeletonLoadingIndicators ? _jsx(FilmGenresSkeleton, {}) : null;
    const genres = getGenresByIds(film.genreIds);
    if (isEmptyArray(genres))
        return null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx("ul", Object.assign({ className: b.element('list') }, { children: genres.map(genre => (_jsx("li", Object.assign({ className: b.element('tag') }, { children: i18n.translatable(genre.name) }), genre.id))) })) })));
});
FilmGenres.displayName = 'FilmGenres';
export const FilmGenresSkeleton = () => _jsx("div", { className: b.block({ skeleton: true }) });
FilmGenresSkeleton.displayName = 'FilmGenresSkeleton';
/**
 * The **Film Genres** component renders the genres of a film.
 */
export const FilmGenresComponent = withComponentWrapper(FilmGenres, {}, () => true);
